import type { UserMenuTab } from './types';

const USER_MENU_TABS = ['Socials', 'Mailbox', 'Trades', 'Dungeons'] as const satisfies readonly UserMenuTab[];

export function restoreUserMenuTab(raw: string): UserMenuTab | null {
    if ((USER_MENU_TABS as readonly string[]).includes(raw)) {
        return raw as UserMenuTab;
    }
    return null;
}
